"use client"

import * as React from "react"

/**
 * ThemeProvider - locked to light mode only.
 * Dark mode has been removed from this application.
 *
 * We force `light` on the html element so the `darkMode: 'class'` strategy in
 * tailwind.config.js neutralises every `dark:` utility in the codebase
 * (instead of binding them to the OS `prefers-color-scheme`).
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  React.useLayoutEffect(() => {
    const root = document.documentElement
    root.classList.add("light")
    root.classList.remove("dark")
    root.style.colorScheme = "light"
  }, [])

  return <>{children}</>
}
